import { decrypt } from './Decrypt';

export async function decryptWithSpaces(encryptedValue) {
  if (!encryptedValue) return '';

  const parts = encryptedValue.split(' ').filter(Boolean);

  const decryptedParts = await Promise.all(parts.map((part) => decrypt(part)));

  return decryptedParts.filter(Boolean).join(' ');
}
